import React, { useState } from 'react';
import { Calendar as CalendarIcon, Lock } from 'lucide-react';
import { Badge } from './catalyst/badge';
import { Button } from './catalyst/button';
import { Field, FieldGroup, Label } from './catalyst/fieldset';
import { Heading } from './catalyst/heading';
import { Input } from './catalyst/input';
import { Text } from './catalyst/text';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSubmitting(true);

    try {
      await onLogin(username, password);
    } catch (err) {
      setError(err.response?.data?.error || 'Sign in failed');
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-100 px-4 text-zinc-950">
      <div className="mx-auto flex min-h-screen w-full max-w-6xl items-center justify-center py-10">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-[420px] rounded-2xl border border-zinc-200 bg-white p-8 shadow-xl shadow-zinc-950/5"
      >
        <div className="mb-7 flex items-center justify-between">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-zinc-950 text-white shadow-sm">
            <CalendarIcon className="h-5 w-5" />
          </div>
          <Badge color="zinc">Calendar</Badge>
        </div>

        <Heading className="mb-2 text-2xl">
          Sign in to continue
        </Heading>
        <Text className="mb-8">
          Use your workspace credentials to open the calendar.
        </Text>

        <FieldGroup className="space-y-4">
          <Field>
            <Label>Username</Label>
            <Input
              type="text"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              autoComplete="username"
              disabled={submitting}
            />
          </Field>

          <Field>
            <Label>Password</Label>
            <Input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="current-password"
              disabled={submitting}
            />
          </Field>
        </FieldGroup>

        {error && (
          <div className="mt-4 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
            {error}
          </div>
        )}

        <Button
          type="submit"
          disabled={submitting || !username.trim() || !password}
          className="mt-6 w-full"
        >
          <Lock className="w-4 h-4" />
          {submitting ? 'Signing in...' : 'Sign in'}
        </Button>
      </form>
      </div>
    </div>
  );
}
